/**
 * Flag Disputed Debts — subsection 4 (/sframe-199-s4)
 */

import { useParams } from 'react-router-dom';
import DebtReviewSectionShell, { type ChecklistItemDef } from './DebtReviewSectionShell';

const ITEMS: ChecklistItemDef[] = [
  {
    id: 'dispute-1',
    title: 'Review for Fraud',
    description: 'Check for unauthorized accounts, identity theft, or fraudulent charges.',
  },
  {
    id: 'dispute-2',
    title: 'Issue Dispute Notices',
    description: 'Send written disputes to creditors with documentation.',
  },
  {
    id: 'dispute-3',
    title: 'Pause Automatic Payments',
    description: 'Cancel any auto-pay associated with disputed accounts.',
  },
];

export default function ReviewOrganize_FlagDisputed() {
  const { estateId } = useParams<{ estateId: string }>();

  return (
    <DebtReviewSectionShell
      estateId={estateId}
      title="Flag Disputed Debts"
      sectionIndex={4}
      checklistFrameId="sframe-199-s4"
      hubSectionKey="s4"
      items={ITEMS}
    />
  );
}
